import {JSX} from "react";

import {Typography} from "@/shared/ui/data-display/typography";
import {FontWeight, ResponsiveSize} from "@/shared/ui/data-display/typography/typography";

interface Props {
    children?: string;
    size?: ResponsiveSize;
    weight?: FontWeight;
    className?: string;
}

const SIZE_DEFAULT: ResponsiveSize = {desktop: 32, mobile: 20};

export function SliderTestimonialsTitle({children, size = SIZE_DEFAULT, weight = 500, className}: Props): JSX.Element {
    const rootClassName = className ? `slider-testimonials__title ${className}` : "slider-testimonials__title";

    return (
        <div className={rootClassName}>
            <Typography className="slider-testimonials__title-h" as="h2" size={size} weight={weight}>
                {children}
            </Typography>
        </div>
    );
}
